<div *transloco="let t">
	<div id="coAppOfferedOuterDiv" class="status-co-app-offered">
		<div class="header-section">
			<header class="op-header-1">
				{{
					t('CO_APP.APPLY.heading', {
						primaryApplicant: (coAppDetails.firstName + ' ' + coAppDetails.lastName) | titlecase
					})
				}}
			</header>
			<div class="op-light-black">
				<p>{{ t('CO_APP.APPLY.description', { primaryApplicant: coAppDetails.firstName | titlecase }) }}</p>
			</div>
		</div>

		<section class="benefits" id="benefits-section">
			<header class="op-header-3">{{ t('CO_APP.APPLY.financeCanHelp') }}</header>
			<div class="body op-light-black">
				<div class="foot-note">
					<mat-icon svgIcon="op-checkMark-rounded"></mat-icon>
					<label>{{
						t('CO_APP.APPLY.increaseApprovalChance', { primaryApplicant: coAppDetails.firstName | titlecase })
					}}</label>
				</div>
				<div class="foot-note">
					<mat-icon svgIcon="op-checkMark-rounded"></mat-icon>
					<label>{{ t('CO_APP.APPLY.buildCredit') }}</label>
				</div>
			</div>
		</section>

		<section class="requirements" id="requirements-section">
			<mat-expansion-panel expanded="true">
				<mat-expansion-panel-header>
					<mat-panel-title class="op-header-3"> {{ t('CO_APP.OFFER.REQUIREMENTS.header') }}</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="op-body-1-font op-mt-16">
					<ul class="requirements-list">
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.noActiveLoan') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.above18') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.noPriorLoan') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.sameState') }}</li>
					</ul>
					<div class="op-mt-16 disclaimer op-label">
						<label>{{ t('CO_APP.OFFER.REQUIREMENTS.disclaimer') }}</label>
					</div>
				</div>
			</mat-expansion-panel>
		</section>

		<op-co-app-common-questions
			id="op-co-app-common-questions"
			[questionType]="questionTypeEnum.APPLY"
			[data]="coAppDetails"
			*ngIf="coAppDetails"
		></op-co-app-common-questions>
	</div>

	<footer id="footer-section">
		<div class="op-center" [ngClass]="isFooterVisible ? 'button-container' : 'floating-button-container'">
			<button
				class="op-full-width floating-button"
				mat-flat-button
				color="primary"
				name="callNowBtn"
				id="callNowBtn"
				[opTagClick]="'co-app-invite call-us'"
				(click)="callUs()"
				type="button"
			>
				{{ t('CO_APP.APPLY.callUs') }}
			</button>
		</div>
		<div class="op-mt-8 disclaimer">
			<label class="op-light-black op-micro">{{ t('CO_APP.OFFER.FOOTER.disclaimer') }}</label>
		</div>
	</footer>
</div>
